// angular
import {NgModule} from "@angular/core";
import {RouterModule, Routes} from '@angular/router';
// app
import {IndexPageComponent} from "./pages/index/index-page.component";
import {DebugPageComponent} from "./pages/debug/debug-page.component";
import {NotFoundPageComponent} from './pages/error/not-found-page.component';
import {LivePageComponent} from "./pages/lives/live-page.component";
import {LiveTermsPageComponent} from "./pages/terms/live-terms-page.component";
// guard
import {ExistClientIdGuard} from "./guards/exist-client-id-guard";
import {NotProductionGuard} from "./guards/not-production-guard";
import {LoginUserTermsAgreedGuard} from "./guards/login-user-terms-agreed-guard";
import {ServerErrorPageComponent} from "./pages/error/server-error-page.component";
import {MagazinePageComponent} from "./pages/magazines/magazine-page.component";
import {ViewPageComponent} from "./pages/view/view-page.component";
import { PointManagePageComponent } from "./pages/point/point-manage-page.component";
import { RevenueManagePageComponent } from "./pages/revenue/revenue-manage-page.component";

const routes: Routes = [
  {
    path: '',
    component: IndexPageComponent,
  },
  {
    path: 'debug',
    canActivate: [NotProductionGuard, ExistClientIdGuard], // 本番環境ではデバッグページは利用不可
    component: DebugPageComponent,
  },
  {
    path: 'magazines/:magazineId',
    component: MagazinePageComponent,
  },
  {
    path: 'lives/:liveId',
    canActivate: [ExistClientIdGuard, LoginUserTermsAgreedGuard],
    component: LivePageComponent,
  },
  {
    path: 'view/:magazineId',
    canActivate: [],
    component: ViewPageComponent,
  },
  {
    path: 'terms/live',
    component: LiveTermsPageComponent,
  },
  {
    path: 'point',
    component: PointManagePageComponent, 
  },
  {
    path: 'revenue',
    component: RevenueManagePageComponent, 
  },
  {
    path: 'errors/server',
    component: ServerErrorPageComponent,
  },
  {
    path: '**',
    component: NotFoundPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, enableTracing: false, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
